

var _subscriptionV1Terms = _interopRequireDefault(require("./subscriptionV1Terms"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
module.exports = {
  getFormattedAmount: _subscriptionV1Terms["default"].getFormattedAmount,
  getTermsText: _subscriptionV1Terms["default"].getTermsText,
  getNumericValueNonZero: _subscriptionV1Terms["default"].getNumericValueNonZero,
  isNumericValue: _subscriptionV1Terms["default"].isNumericValue,
  getTaxDisclaimer: _subscriptionV1Terms["default"].getTaxDisclaimer
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/subscriptionV1-terms/index.js
// module id = ../node_modules/xo-page-components/src/subscriptionV1-terms/index.js
// module chunks = 0